//TODO: move this token into the common config
export const accessToken =
  'pk.eyJ1IjoidGVycmFnby1hY2NvdW50IiwiYSI6ImNrZm4wdGN3ZDFreXAycm8wbjg4amV1dzQifQ.36pfqYSU_1ChaGGRM4i1mQ';
